export default "__VITE_ASSET__DDK$WZXd__"